const listaDeTiposTarefas = (state) => {
    return state.items;
}

const listaDeSubTiposHierarquias = (state) => {
    return state.subTiposHierarquias;
}

const listaDeMacroTiposHierarquias = (state) => {
    return state.macroTiposHierarquias;
}

const loadingTiposTarefas = (state) => {
    return state.carregando
}

export {
    listaDeTiposTarefas,
    listaDeSubTiposHierarquias,
    listaDeMacroTiposHierarquias,
    loadingTiposTarefas
}